import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import propertyReducer from "./propertyReducer";

export default combineReducers({
  auth: authReducer,
  property: propertyReducer,
  errors: errorReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js